import { FC, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';

import Spinner from '../../atoms/Spinner/Spinner';
import { LandscapeAddStoryTemplate } from '../../templates';
import { StoryResponseDto } from '../../../store/landscapeAPI/story/dto/response/story-response.dto';
import { useNavigate, useParams } from 'react-router-dom';
import { getUUID } from '../../../utils/UUID';
import { StorySaveRequestDto } from '../../../store/landscapeAPI/story/dto/request/story-save-request.dto';
import {
  fetchStoriesByCompactId,
  saveCompactStory,
} from '../../../store/landscapeAPI/story/reducers/story.slice';
import { MediaSaveResponseDto } from '../../../store/mediaAPI/media/dto/response/media-save-response';
import { saveMedia } from '../../../store/mediaAPI/media/reducers/media.slice';
import { ImageMeta } from '../../../store/mediaAPI/media/dto/request/media-save-request';

interface CommoditiesChoosePageProps {}

const LandscapeAddStoryPage: FC<CommoditiesChoosePageProps> = () => {
  const { id } = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [imageMeta, setImageMeta] = useState<ImageMeta>();
  const { status } = useSelector((state: RootState) => state.storySlice);
  const { status: mediaStatus } = useSelector(
    (state: RootState) => state.mediaSlice
  );
  const [story, setStory] = useState<StoryResponseDto>({
    name: '',
    story: '',
    writer: '',
    headerImage: '',
    date: '',
    projectId: '',
    compactId: id ?? '',
    id: getUUID(),
    versionId: 0,
    createdByUserId: '',
    createdOnDateTimeUtc: '',
    language: '',
    published: true,
  });

  const handleOnChange = (story: StoryResponseDto) => {
    setStory(story);
  };

  const handleImageOnChange = (imageMeta: ImageMeta) => {
    setImageMeta(imageMeta);
  };

  const callbackFn = async (story: StoryResponseDto) => {
    let image: MediaSaveResponseDto = {
      href: '',
    };
    if (story.headerImage && story.headerImage !== '' && imageMeta) {
      const formData = new FormData();
      formData.append(
        'file',
        new Blob([story.headerImage], {
          type: imageMeta?.imageType ?? 'image/png',
        }),
        imageMeta?.imageSrc
      );
      image = (await dispatch(saveMedia(formData)))
        .payload as MediaSaveResponseDto;
    }
    const storyToSave: StorySaveRequestDto = {
      name: story.name,
      story: story.story,
      writer: story.writer,
      headerImage: image.href,
      date: story.date,
      compactId: story.compactId,
      id: story.id,
      published: story.published,
    };
    await dispatch(
      saveCompactStory({ saveRequest: storyToSave, id: story.compactId })
    );
    if (id) {
      dispatch(fetchStoriesByCompactId(id));
    }
    navigate(`/landscapes/edit/${id}/updates`);
  };

  if (status === 'loading' || mediaStatus === 'loading') {
    return <Spinner />;
  }

  return (
    <LandscapeAddStoryTemplate
      story={story}
      handleOnChange={handleOnChange}
      handleImageOnChange={handleImageOnChange}
      callbackFn={callbackFn}
    />
  );
};

export default LandscapeAddStoryPage;
